import { ClerkOptions } from "@clerk/types";
import { vendrLogoWithPurpleText } from "../app/image";

export const allowedRedirectOrigins = [
  // marketplace
  "https://www.local.vendr-dev.com/",
  "https://www.preview.vendr-dev.com/",
  "https://www.staging.vendr.com/",
  "https://www.vendr.com/",

  // agent
  "https://agent.local.vendr-dev.com/",
  "https://agent.preview.vendr-dev.com/",
  "https://agent.staging.vendr.com/",
  "https://agent.vendr.com/",
];

export const clerkOptions: ClerkOptions = {
  allowedRedirectOrigins,
  appearance: {
    variables: {
      colorPrimary: "#5c3d99",
      colorBackground: "#ffffff",
      colorForeground: "#1a0513",
      colorMutedForeground: "#6a6a6a",
      colorNeutral: "#4a4a4a",
      colorDanger: "#dc2626",
      colorSuccess: "#57cc99",
      fontFamily:
        '"Söhne", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      fontFamilyButtons:
        '"Söhne", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      borderRadius: "0.75rem",
      fontWeight: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
      },
    },
    layout: {
      logoImageUrl: vendrLogoWithPurpleText,
      socialButtonsPlacement: "bottom",
    },
    elements: {
      // Root card container - clean white, no shadows
      rootBox: {
        boxShadow: "none",
      },
      cardBox: {
        boxShadow:
          "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05)",
        borderRadius: "12px",
      },
      card: {
        boxShadow: "none",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
      },
      // Footer - clean white background, no shadow
      footer: {
        backgroundColor: "#ffffff",
        boxShadow: "none",
        borderTop: "none",
        background: "#ffffff",
      },
      footerAction: {
        backgroundColor: "#ffffff",
      },
      footerActionLink: {
        color: "#5c3d99",
        fontWeight: "500",
      },
      // Primary button - simple black button, no hover effect
      formButtonPrimary: {
        backgroundColor: "#1a0513 !important",
        color: "#ffffff !important",
        borderRadius: "9999px",
        fontWeight: "500",
        fontSize: "15px",
        height: "40px",
        border: "none !important",
        boxShadow: "none !important",
      },
      "formButtonPrimary:hover": {
        backgroundColor: "#1a0513 !important",
        borderColor: "transparent !important",
        boxShadow: "none !important",
      },
      "formButtonPrimary:focus": {
        backgroundColor: "#1a0513 !important",
        borderColor: "transparent !important",
        boxShadow: "none !important",
      },
      "formButtonPrimary:active": {
        backgroundColor: "#1a0513 !important",
        borderColor: "transparent !important",
      },
      // Hide the chevron icon
      formButtonPrimaryIcon: {
        display: "none",
      },
      buttonArrowIcon: {
        display: "none",
      },
      // Input styling
      formFieldInput: {
        borderRadius: "8px",
        borderColor: "rgba(0, 0, 0, 0.1)",
        fontSize: "15px",
        height: "44px",
      },
      "formFieldInput:focus": {
        borderColor: "#5c3d99",
        boxShadow: "0 0 0 2px rgba(92, 61, 153, 0.15)",
      },
      // Header styling
      headerTitle: {
        fontWeight: "600",
        fontSize: "24px",
        color: "#1a0513",
      },
      headerSubtitle: {
        color: "#6a6a6a",
      },
      // Social button styling
      socialButtonsBlockButton: {
        borderRadius: "9999px",
        borderColor: "rgba(0, 0, 0, 0.1)",
        height: "44px",
      },
      socialButtonsIconButton: {
        borderRadius: "8px",
        borderColor: "rgba(0, 0, 0, 0.1)",
      },
      selectButton__countryCode: {
        borderRadius: "8px",
      },
      // Modal styling
      modalBackdrop: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      },
      // Close button - remove focus ring
      modalCloseButton: {
        outline: "none",
        boxShadow: "none",
      },
      "modalCloseButton:focus": {
        outline: "none",
        boxShadow: "none",
      },
      "modalCloseButton:focus-visible": {
        outline: "none",
        boxShadow: "none",
      },
    },
  },
  localization: {
    formFieldLabel__emailAddress: "Work Email",
    formFieldInputPlaceholder__emailAddress:
      "Please enter your work email address",
    signUp: {
      start: {
        title: "Create your free account",
      },
    },
    signIn: {
      start: {
        title: "Sign in to Vendr",
      },
    },
  },
};
